var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.343,14.216C19.409,14.213 19.475,14.212 19.541,14.212C22.007,14.212 24.008,16.086 24.008,18.394C24.008,20.702 22.007,22.576 19.541,22.576C19.427,22.576 19.315,22.572 19.203,22.565L15.493,22.565L15.493,22.567L10.505,22.567L10.505,23.927L6.506,20.935L10.508,17.946L10.507,19.55L14.025,19.55L14.025,19.547L19.057,19.547C20.008,19.359 20.728,18.49 20.728,17.449C20.728,16.308 19.864,15.375 18.777,15.335L18.777,15.333L0.439,15.333L0.439,14.216L19.343,14.216Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.943115,0,0,1.06806,0.698793,-1.31607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.169,15.59L19.096,15.577L19.169,15.577L19.169,15.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.192282,0,0,0.192282,-0.45658,-0.963011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.6,51.4L84.3,51.4L43,10.1C40.9,8 37.5,7.8 35.2,9.5C33,11.2 32.2,14.3 33.4,16.8L49.4,51.3L28.2,51.3L10.3,35.3C8.4,33.6 5.5,33.7 3.7,35.5C2.4,36.8 1.9,38.8 2.6,40.6L8.2,55.5C8.5,56.2 9,56.7 9.6,57L32.6,70C33.1,70.3 33.6,70.4 34.1,70.4L117.6,70.4C122.8,70.4 127.1,66.1 127.1,60.9C127.1,55.7 122.8,51.4 117.6,51.4Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneReturn);
export default __webpack_public_path__ + "static/media/airplane-return.77ae3286.svg";
export { ForwardRef as ReactComponent };